<mat-dialog-content>
	<div class="flex flex-col" *transloco="let t">
		<div class="bg-card rounded-full border px-4 bg-white flex flex-row justify-start items-center w-[400px] md:w-auto mb-1">
			<mat-icon [svgIcon]="icons.get('search')" size="20px"></mat-icon>
			<input
				#input
				[formControl]="searchValue"
				class="px-4 py-3 border-0 outline-none w-full bg-transparent"
				matInput
				name="searchField"
				placeholder="{{ t('commonActions.search') }}"
				type="search" />
		</div>
		@if (allIcons().length === 0) {
			<div>
				{{ t('settings.devSettings.frontendTools.noIconsFoundForFilter') }}
			</div>
		} @else {
			<div class="grid grid-flow-row-dense grid-cols-5">
				@for (icon of allIcons(); track icon.label) {
					<div class="card">
						<div class="card overflow-hidden">
							<div
								class="p-4 text-center hover:bg-hover trans-ease-out cursor-pointer relative"
								(click)="copyLabelToClipboard(icon.label)"
								[cdkCopyToClipboard]="icon.label"
								matRipple>
								<mat-icon [svgIcon]="icon.path"></mat-icon>
								<h4 class="title mb-1 mt-3" title="Label">{{ icon.label }}</h4>
								@if (icon.path.startsWith('mat')) {
									<h4 class="title mb-1 mt-3">Material</h4>
								} @else if (icon.path.startsWith('flag')) {
									<h4 class="title mb-1 mt-3">Flag</h4>
								} @else if (icon.path.startsWith('logo')) {
									<h4 class="title mb-1 mt-3">Logo</h4>
								} @else {
									<h4 class="title mb-1 mt-3">Arasys</h4>
								}
							</div>
						</div>
					</div>
				}
			</div>
		}
		@if (duplicates().length > 0) {
			<hr />
			<h3>Duplicates found</h3>
			@for (duplicate of duplicates(); track duplicate.label) {
				<div>{{ duplicate.label }}</div>
			}
		}
	</div>
</mat-dialog-content>
